import z from 'zod'

export type Fight = z.infer<typeof Z_Fight>

const Z_Fight = z.object({
    id: z.string(),
    name: z.string(),
    updatedAt: z.string(),
    createdAt: z.string(),
})

export type Actor = z.infer<typeof Z_Actor>

const Z_Actor = z.object({
    fightId: z.string(),

    id: z.string(),
    name: z.string(),
    ordinal: z.number(),
    color: z.string(),
    isBoss: z.boolean(),
    hidden: z.boolean()
})

export type Spell = z.infer<typeof Z_Spell>

const Z_Spell = z.object({
    actorId: z.string(),

    id: z.string(),
    name: z.string(),
    ordinal: z.number(),
    color: z.string(),

    duration: z.number(),
    cooldown: z.number(),
    // If a class needs to do a set rotation before pressing a CD,
    // this is that time
    ramp: z.number(),
})

export type SpellAssignment = z.infer<typeof Z_SpellAssignment>

const Z_SpellAssignment = z.object({
    spellId: z.string(),

    id: z.string(),
    offset: z.number(),

    hideTimestamp: z.boolean().optional(),
    overrideDuration: z.number().optional(),
    overrideCooldown: z.number().optional(),
    overrideRamp: z.number().optional()
})

export type FightData = z.infer<typeof Z_FightData>

export const Z_FightData = z.object({
    fight: Z_Fight,
    actors: z.array(Z_Actor),
    spells: z.array(Z_Spell),
    assignments: z.array(Z_SpellAssignment)
})